export default __webpack_public_path__ + "static/media/calendar.18f53d9f.svg";